import { useState } from "react";
import api from "../../../services/api";
import {
  FaFileExcel,
  FaShoppingBag,
  FaDollarSign,
  FaChartLine,
  FaDownload,
  FaSearch,
} from "react-icons/fa";

function ReportsAdmin() {
  const [month, setMonth] = useState(new Date().getMonth() + 1);
  const [year, setYear] = useState(new Date().getFullYear());
  const [report, setReport] = useState([]);
  const [summary, setSummary] = useState({ totalOrders: 0, totalRevenue: 0 });
  const [loading, setLoading] = useState(false);

  const token = localStorage.getItem("token");

  const translateDelivery = (value) =>
    value === "delivery" ? "משלוח" : "איסוף עצמי";

  const translatePayment = (value) =>
    ({ cash: "מזומן", visa: "כרטיס אשראי", paypal: "PayPal" })[value] || value;

  const translateStatus = (value) => {
    const statuses = {
      Pending: "התקבלה",
      Paid: "התשלום אושר",
      Preparing: "בהכנה",
      Shipped: "במשלוח",
      Delivered: "נמסרה",
      Cancelled: "בוטלה",
    };
    return statuses[value] || value;
  };

  const fetchReport = async () => {
    setLoading(true);
    try {
      const res = await api.get(
        `/admin/reports/monthly?month=${month}&year=${year}`,
        { headers: { Authorization: `Bearer ${token}` } },
      );

      setReport(res.data.orders || []);
      setSummary(res.data.summary || { totalOrders: 0, totalRevenue: 0 });
    } finally {
      setLoading(false);
    }
  };

  const downloadExcel = async () => {
    const res = await api.get(
      `/admin/reports/monthly/download?month=${month}&year=${year}`,
      {
        headers: { Authorization: `Bearer ${token}` },
        responseType: "blob",
      },
    );

    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `דוח-הזמנות-${month}-${year}.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  };

  return (
    <section className="dashboard-section reports-section">
      <div className="section-title">
        <div className="section-title-main">
          <span className="section-icon"><FaChartLine /></span>
          <div>
            <h2>דוחות חודשיים</h2>
            <p>בחירת תקופה, צפייה בסיכום וייצוא נתונים ל-Excel</p>
          </div>
        </div>
      </div>

      <div className="report-control-panel">
        <div className="report-period-fields">
          <label className="form-field compact">
            <span>חודש</span>
            <input type="number" min="1" max="12" value={month} onChange={(e) => setMonth(e.target.value)} />
          </label>

          <label className="form-field compact">
            <span>שנה</span>
            <input type="number" value={year} onChange={(e) => setYear(e.target.value)} />
          </label>
        </div>

        <div className="report-actions">
          <button className="report-view-btn" onClick={fetchReport} disabled={loading}>
            <FaSearch /> {loading ? "טוען דוח..." : "הצגת דוח"}
          </button>
          <button className="report-download-btn" onClick={downloadExcel}>
            <FaDownload /> הורדת Excel
          </button>
        </div>
      </div>

      <div className="report-summary">
        <article>
          <span className="report-summary-icon"><FaShoppingBag /></span>
          <div><span>סה״כ הזמנות בתקופה</span><strong>{summary.totalOrders}</strong><small>לפי החודש שנבחר</small></div>
        </article>

        <article className="revenue-report-card">
          <span className="report-summary-icon"><FaDollarSign /></span>
          <div><span>שווי כלל ההזמנות</span><strong>₪ {summary.totalRevenue}</strong><small>סיכום הזמנות בדוח</small></div>
        </article>

        <article>
          <span className="report-summary-icon"><FaFileExcel /></span>
          <div><span>ייצוא נתונים</span><strong>Excel</strong><small>קובץ מוכן להורדה</small></div>
        </article>
      </div>

      <div className="report-table-heading">
        <div>
          <h3>פירוט הזמנות</h3>
          <p>כל ההזמנות שנמצאו בתקופה שנבחרה</p>
        </div>
        <span className="section-count">{report.length} רשומות</span>
      </div>

      <div className="admin-table-wrap">
        <table>
          <thead>
            <tr>
              <th>מספר הזמנה</th>
              <th>לקוח</th>
              <th>טלפון</th>
              <th>סכום</th>
              <th>קבלה</th>
              <th>תשלום</th>
              <th>סטטוס</th>
              <th>תאריך</th>
            </tr>
          </thead>

          <tbody>
            {report.length === 0 ? (
              <tr><td colSpan="8" className="empty-table-cell">בחרו חודש ושנה ולחצו על "הצגת דוח"</td></tr>
            ) : (
              report.map((order) => (
                <tr key={order.order_id}>
                  <td><span className="order-number">#{order.order_id}</span></td>
                  <td><strong>{order.first_name} {order.last_name}</strong></td>
                  <td>{order.phone}</td>
                  <td><strong>₪ {order.total_price}</strong></td>
                  <td>{translateDelivery(order.delivery_method)}</td>
                  <td>{translatePayment(order.payment_method)}</td>
                  <td>{translateStatus(order.status)}</td>
                  <td>{new Date(order.order_date).toLocaleDateString("he-IL")}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </section>
  );
}

export default ReportsAdmin;
